module.exports = __webpack_public_path__ + "static/media/manfred-1.bf56b845.jpg";